import { RootState } from '../../../definitions/store';

export const selectTipsAndTricksList = (state: RootState) => state.tipsAndTricks.tipsAndTricks;
